import { useAppSelector } from "@/store";
import { selectIsAuthenticated } from "@/store/auth";
import type { PropsWithChildren } from "react";
import { memo } from "react";
import { Navigate } from "react-router-dom";

const OnlyUnauthenticatedRoute = memo(({ children }: PropsWithChildren) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  return isAuthenticated ? <Navigate to="/" /> : children;
});

export default OnlyUnauthenticatedRoute;
